<template>
<div class="bb-transactions"
     :style="{height: !isHidden ? heightContent : 0}"
>
  <transition name="fade">
    <div class="bb-transactions__content"
         ref="bbTransactions"
         v-if="display"
         :class="{'bb-transactions__content_hide': isHidden}"
    >
      <div class="bb-transactions-row">
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_header"
        >
          DESCRIPTION
        </div>
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_header
                    bb-transactions-row__item_center"
        >
          DEBIT, AED
        </div>
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_header
                    bb-transactions-row__item_center"
        >
          CREDIT, AED
        </div>
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_header
                    bb-transactions-row__item_end"
        >
          BALANCE, AED
        </div>
      </div>
      <div class="bb-transactions-row"
           v-for="transaction in transactions"
           :key="transaction.id"
      >
        <div class="bb-transactions-row__item-wrapper">
          <div class="bb-transactions-row__item">{{formatDate(transaction.date)}}</div>
          <div class="bb-transactions-row__item">{{transaction.description}}</div>
        </div>
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_center"
        >
          {{numeralConvertNumber(transaction.debit)}}
        </div>
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_center"
        >
          {{numeralConvertNumber(transaction.credit)}}
        </div>
        <div class="bb-transactions-row__item
                    bb-transactions-row__item_end"
        >
          {{numeralConvertNumber(transaction.balance)}}
        </div>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
import {get} from 'lodash'
import moment from 'moment'
import convertNumber from '@/mixin/convertNumber'
export default {
  name: 'Transactions',
  props: ['row'],
  mixins: [convertNumber],
  computed: {
    transactions: {
      get: function () {
        return get(this.row, 'transactions', [])
      }
    },
    display () {
      return get(this.row, '$accordionContent', false)
    }
  },
  data () {
    return {
      heightContent: 'auto',
      isHidden: true
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD-MMM-YYYY')
    },
    setOpen () {
      this.isHidden = !this.display
    },
    calcHeight () {
      const node = this.$refs.bbTransactions
      this.heightContent = node ? node.offsetHeight + 'px' : 'auto'
      this.setOpen()
    }
  },
  watch: {
    display (newVal) {
      if (newVal) {
        this.$nextTick(this.calcHeight)
      } else {
        this.isHidden = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-transactions {
    @include global-font;
    transition: 0.25s ease-out;

    &__content {
      background-color: $color-wild-sand;
      margin-top: 18px;
      margin-left: 15px;
      border-radius: 4px;
      padding: 19px 16px;
      margin-right: -16px;
      transition: 0.3s;

      &_hide {
        opacity: 0;
        z-index: -1;
        pointer-events: none;
      }
    }

    &-row {
      display: grid;
      grid-template-columns: minmax(77px, 532px) minmax(62px, 126px) minmax(71px, 102px) auto;
      margin-bottom: 23px;

      &:last-child {
        margin-bottom: 0;
      }

      &__item-wrapper {
        display: grid;
        grid-template-columns: minmax(78px, 116px) minmax(372px, 416px);
      }

      &__item {
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;

        &_header {
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
          color: $color-denim;
        }

        &_end {
          text-align: end;
        }

        &_center {
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteTable/Transactions.vue